<template>
<!-- eslint-disable -->
  <div class="indented">
      <h3>{{ name }}</h3>
      <div v-for="product in selectedproduct">
        <div class="form-horizontal">
          <h4>Product Details</h4>
          <hr />
          <div class="form-group spaced">
            Name:
            <div class="col-md-10">
              {{ product.productname }}
            </div>
          </div>

          <div class="form-group spaced">
            Description:
            <div class="col-md-10">
              {{ product.description }}
            </div>
          </div>

          <div class="form-group spaced">
            Price:
            <div class="col-md-10">
              € {{ product.price }}
            </div>
          </div>
          <div class="spacer"></div>
          <div class="form-group spaced">
            Picture:
            <div class="col-md-10">
              <img id='image' :src="$options.filters.removetilde(product.picture)">
            </div>
          </div>
          <div class="form-group spaced">
            <div class="spacer"></div>
              <div class="col-md-10">
                <a href="#" @click="goBack"><< Back</a>
              </div>
          </div>
          <div class="form-group spaced">
            <div v-if="product.alternateproducts">See also these alternative products:</div>
            <div class="spacer"></div>
            <div class="col-md-10">
              <div v-for="altproduct in product.alternateproducts">
                <div class="proditem">
                  <div class="prodname">{{ altproduct.productname }}</div>
                  <img class='image' :src="$options.filters.removetilde(altproduct.picture)" @click="showAltProduct(altproduct.id)">
                </div>
              </div>
            </div>
            <div class="spacer"></div>
            <div class="form-group">
              <div class="col-md-10">
                <input type="button" value="Add Alternative Products" class="button btn btn-default" @click="getAllProductsButOne" />
              </div>
            </div>
            <div class="spacer"></div>
            <div v-show="altprodchooser">
              Click checkbox to add as a product alternative:
              <div class="spacer"></div>
              <div v-for="altproduct in altproducts">
                <div class="proditem">
                  <div class="prodname">{{ altproduct.productname }}</div>
                  <img class='image' :src="$options.filters.removetilde(altproduct.picture)">
                  <input v-if="IdChecked(altproduct.id)" checked type="checkbox" :id="altproduct.id" @click="checkHandler">
                  <input v-else-if="!IdChecked(altproduct.id)" type="checkbox" :id="altproduct.id" @click="checkHandler">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>

</template>

<script>
  import axios from 'axios';
  import qs from 'qs'; // qs was installed from command prompt with npm install qs
  export default {
    name: 'Comp_ProductDetails',
    props: ['name','selectedproduct','id','catid'],
    data() {
      return {
        altprodchooser: false,
        altproducts: [],
        checkedarray: []
      }
    },
    methods: {
      getAllProductsButOne() {
        this.altprodchooser = !this.altprodchooser;
        axios.get('https://api-japie.top/meubels/getallproductsfromcategory?notproductid=' + this.id + '&catid=' + this.catid).then(response => {
          var jsonData = response.data;
          this.altproducts = jsonData;
          //alert(JSON.stringify(jsonData, undefined, 2));
        })
          .catch(err => {
            alert(err);
          })

        axios.get('https://api-japie.top/meubels/checkedarray?productid=' + this.id).then(response => {
          var jsonData = response.data;
          this.checkedarray = jsonData;
          //alert(JSON.stringify(jsonData, undefined, 2));
        })
          .catch(err => {
            alert(err);
          })
      },
      IdChecked: function (id) {
        if (this.checkedarray.includes(id)) {
          return true
        }
        else {
          return false
        }
      },
      checkHandler(e) {
        if (e.target.checked) { // checked
          //alert('you checked: ' + e.target.id);
          var IdtoInsert = e.target.id;
          const body = {
            "id": this.id,
            "alternativeproductid": IdtoInsert
          }
          var url = 'https://api-japie.top/meubels/addasalternativeproduct';
          const options = {
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: qs.stringify(body),
            url,
          };
          axios(options).then(response => {
            this.$emit('refreshalternativeproducts');
          })
            .catch(err => {
              alert(err);
            });
        }
        else { // not checked
          //alert('you unchecked: ' + e.target.id);
          var IdtoDelete = e.target.id;
          const body = {
            "id": this.id,
            "alternativeproductid": IdtoDelete
          }
          var url = 'https://api-japie.top/meubels/removeasalternativeproduct';
          const options = {
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: qs.stringify(body),
            url,
          };
          axios(options).then(response => {
            this.$emit('refreshalternativeproducts');
          })
            .catch(err => {
              alert(err);
            });
        }
      },
      showAltProduct(altprodid) {
        //alert(altprodid);
        var id = altprodid;
        this.$emit('unloadaltprod');
        this.$router.push({ name: 'AlternativeProductDetails', query: { Id: id } });
      },
      goBack() {
        this.$router.push('/ShowProductsofCat');
      }
    },
    filters: {
      removetilde: function (string) {
        var firstChar = string.charAt(0);
        if (firstChar == '~') {
          return string.substring(1, string.length);
        }
        else {
          return string;
        }
      }
    }
  }
</script>

<style scoped src="bootstrap/dist/css/bootstrap.min.css">
  /* install bootstrap first by typing 'npm install bootstrap' in command prompt */
</style>

<style scoped>

  .indented {
    margin: 20px;
    max-width: 550px;
  }

  .spacer {
    height:25px;
    border: 0px solid black;
    clear: both;
  }

  .smallspacer {
    height: 5px;
    border: 0px solid black;
    clear: both;
  }

  .spaced {
    margin-bottom: 10px;
  }

  .image {
      width: 90px;
      float: left;
      margin-right: 20px;
  }

  .button {
    border: 1px solid gray;
  }

  .prodname {
      font-size: 10px;
  }

  .proditem {
      float: left;
      margin-right: 15px;
  }
</style>




// WEBPACK FOOTER //
// src/Comp_ProductDetails.vue